import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectInitialFormData = (state: RootState) =>
  state.app.scheduleCargoTemplateDialog.initialFormData;

export const selectResetFormData = (state: RootState) =>
  state.app.scheduleCargoTemplateDialog.resetFormData;

const selectPreviousFormData = (state: RootState) =>
  state.app.scheduleCargoTemplateDialog.previousFormData;

export const selectFormDataForWhenOpeningModal = createSelector(
  selectInitialFormData,
  selectPreviousFormData,
  (initial, previous) => previous || initial
);

export const selectIsSaving = (state: RootState) =>
  state.app.scheduleCargoTemplateDialog.isSaving;

// The revision the open template dialog saves against (DORA-441).
export const selectLoadedRevision = (state: RootState) =>
  state.app.scheduleCargoTemplateDialog.loadedDataRevisionNumber;

// Someone else's change clashed with the user's unsaved edits (DORA-441).
export const selectRemoteConflict = (state: RootState) =>
  state.app.scheduleCargoTemplateDialog.remoteConflict;
